export const SMSCOLUMN = [
    {
        Header: "Type",
        Footer: "Type",
        accessor: "type",
        sticky: "left",
    },
    {
        Header: "Title",
        Footer: "Title",
        accessor: "title",
    },
    {
        Header: "Header",
        Footer: "Header",
        accessor: "header",
    },
    {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
    },
    {
        Header: "Delete",
        Footer: "Delete",
        accessor: "delete",
    },
];
